import z from 'zod';
import { AllCharLabelSchema, HexColorSchema, SubjectSchema } from '../common/schemas';
import { DBLegacyTopicLabelSchema, DBLegacyTopicTopicIdSchema } from '../legacyTopics/schemas';
import { DEFAULT_LEGACY_TOPIC_GROUP_COLOR } from './constants';

/**
 * Shared & Helper Schemas
 */

/**
 * DB Schemas
 */

export const DBLegacyTopicGroupSubjectSchema = SubjectSchema;
export const DBLegacyTopicGroupGroupIdSchema = z.string().regex(/^[a-z0-9]{1,20}$/);
export const DBLegacyTopicGroupBadgeLabelSchema = z.string().regex(/^[a-zA-Z0-9]{2}$/);
export const DBLegacyTopicGroupColorSchema = HexColorSchema;
export const DBLegacyTopicGroupLabelSchema = AllCharLabelSchema.min(1).max(64);
export const DBLegacyTopicGroupTopicsSchema = z.record(
  z.lazy(() => DBLegacyTopicTopicIdSchema),
  z
    .object({
      key: z.lazy(() => DBLegacyTopicTopicIdSchema),
      label: z.lazy(() => DBLegacyTopicLabelSchema),
    })
    .strict()
);

export const DBLegacyTopicGroupSchema = z.object({
  subject: DBLegacyTopicGroupSubjectSchema,
  groupId: DBLegacyTopicGroupGroupIdSchema,
  badgeLabel: DBLegacyTopicGroupBadgeLabelSchema,
  color: DBLegacyTopicGroupColorSchema,
  label: DBLegacyTopicGroupLabelSchema,
  // .optional() indicates to ElectroDB that keys of this dynamic field may be deleted
  topics: DBLegacyTopicGroupTopicsSchema.optional(),
});

/**
 * Client Schemas
 */

export const LegacyTopicGroupSubjectSchema = DBLegacyTopicGroupSubjectSchema;
export const LegacyTopicGroupGroupIdSchema = DBLegacyTopicGroupGroupIdSchema;
export const LegacyTopicGroupBadgeLabelSchema = DBLegacyTopicGroupBadgeLabelSchema;
export const LegacyTopicGroupColorSchema = DBLegacyTopicGroupColorSchema;
export const LegacyTopicGroupLabelSchema = DBLegacyTopicGroupLabelSchema;
export const LegacyTopicGroupTopicsSchema = z.array(
  z.object({
    topicId: LegacyTopicGroupGroupIdSchema,
    label: LegacyTopicGroupLabelSchema,
  })
);

export const LegacyTopicGroupSchema = z.object({
  subject: LegacyTopicGroupSubjectSchema.meta({ title: 'Subject' }),
  groupId: LegacyTopicGroupGroupIdSchema.meta({ title: 'Group ID' }),
  badgeLabel: LegacyTopicGroupBadgeLabelSchema.meta({ title: 'Badge label' }),
  color: LegacyTopicGroupColorSchema.default(DEFAULT_LEGACY_TOPIC_GROUP_COLOR).meta({
    title: 'Color',
  }),
  label: LegacyTopicGroupLabelSchema.meta({ title: 'Label' }),
  topics: LegacyTopicGroupTopicsSchema.default([]),
});
